<div
  class="combined-box"
  [attr.aria-disabled]="isDisabled"
  [class.disabled]="isDisabled"
>
  <div class="dropdown-input-phone" #dropdownInputPhone>
    <lib-vinnova-dropdown
      [id]="'countrydrop_' + id"
      class="country-code-dropdown"
      [items]="countryCodes"
      [multiple]="false"
      [(ngModel)]="selectedCountry"
      [readonly]="isDisabled"
      (ngModelChange)="selectedCountryChange($event)"
      label="Country code"
      (blur)="onBlur()"
      (focus)="onFocus()"
    >
    </lib-vinnova-dropdown>
  </div>
  <span class="phone-input-border"></span>

  <div class="text-input-phone" #textInputPhone>
    <input
      vinnova-text-input
      class="phone-number-input"
      [inputType]="inputType"
      [(ngModel)]="phoneNumber"
      (ngModelChange)="phoneNumberInputChange($event)"
      [(selectedCountry)]="selectedCountry"
      [error]="hasError()"
      (blur)="onBlur()"
      (focus)="onFocus()"
      [attr.disabled]="isDisabled ? '' : undefined"
      [attr.id]="id"
      [disabled]="isDisabled"
    />
  </div>
</div>
